<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-my-projects">
  <div class="consumer-my-projects--layout">
    <app-consumer-sidebar class="consumer-my-projects--sidebar"></app-consumer-sidebar>
    <div class="consumer-my-projects--content">
      <app-page-header></app-page-header>

      <!-- Loading: checking Compute role -->
      <div *ngIf="accessLevel === 'loading'" class="consumer-my-projects--access consumer-my-projects--access-loading">
        <p>Checking access…</p>
      </div>

      <!-- Full access: Compute in active roles -->
      <ng-container *ngIf="accessLevel === 'full'">
        <app-my-project></app-my-project>
      </ng-container>
    </div>
  </div>
</div>

<!-- Upgrade Your Role modal when Compute access is none or pending -->
<app-modal
  [visible]="showAccessModal"
  header="Upgrade Your Role"
  width="480px"
  [showFooter]="false"
  (visibleChange)="onAccessModalClose()"
>
  <div class="consumer-my-projects--modal-content">
    <!-- Leaf decoration bottom right -->
    <div class="consumer-my-projects--modal-leaf">
      <img src="/assets-leaf.png" alt="" class="consumer-my-projects--modal-leaf-img" />
    </div>
    <div class="consumer-my-projects--modal-body">
      <p *ngIf="accessLevel === 'none'">You need the Compute role to access My Projects. Request the Compute role or contact your administrator.</p>
      <p *ngIf="accessLevel === 'pending'">Your Compute role request is pending <span class="consumer-my-projects--modal-highlight">approval</span>. You will get access to My Projects once it is approved.</p>
      <label class="consumer-my-projects--modal-checkbox">
        <input type="checkbox" [(ngModel)]="doNotShowAccessModalAgain" />
        <span>Do not show this message again</span>
      </label>
      <div class="consumer-my-projects--modal-actions">
        <button
          type="button"
          class="consumer-my-projects--role-upgrade-btn"
          [disabled]="accessLevel === 'pending'"
          (click)="onRoleUpgradeClick()"
        >
          {{ accessLevel === 'pending' ? 'Request Sent' : 'Role Upgrade' }}
        </button>
      </div>
    </div>
  </div>
</app-modal>
